import { Component, Input } from '@angular/core';

@Component({
    selector: 'syn-donut-chart',
    templateUrl: './donut-chart.component.html',
    styleUrls: ['./donut-chart.component.scss']
})
export class DonutChartComponent {
    @Input() data: {name: string; value: number}[];
    @Input() text: string;
    @Input() textDetail: string;
    @Input() caption: string;

    public colorScheme = {
        domain: ['#632bbe', 'rgba(0,0,0,0.06)']
    };
}
